import { render, staticRenderFns } from "./Ocr.vue?vue&type=template&id=12799afe&scoped=true&"
import script from "./Ocr.vue?vue&type=script&lang=js&"
export * from "./Ocr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12799afe",
  null
  
)

export default component.exports